import { useState } from "react";
import { get } from "lodash";

import useCart from "grandus-lib/hooks/useCart";
import { Select, Radio, InputNumber, Button } from "antd";
import { ShoppingOutlined } from "@ant-design/icons";
import EnhancedEcommerce from 'utils/ecommerce';
import TagManager from 'grandus-lib/utils/gtag';
import { useRouter } from "next/router";
const { Option } = Select;

const PartSize = ({ stores, productId, selectedValue, handleChange }) => {
  if (stores.length <= 4) {
    return (
      <Radio.Group
        onChange={(e) => handleChange(e.target.value)}
        value={selectedValue}
      >
        {stores.map((store, index) => (
          <Radio
            key={`product-${productId}-store-${get(
              store,
              "id"
            )}-option-${index}`}
            value={get(store, "id")}
          >
            {get(store, "name")}
          </Radio>
        ))}
      </Radio.Group>
    );
  } else {
    return (
      <Select
        placeholder={"Vyberte možnosť"}
        onChange={(value) => handleChange(value)}
        value={selectedValue}
      >
        {stores.map((store, index) => (
          <Option
            key={`product-${productId}-store-${get(
              store,
              "id"
            )}-option-${index}`}
            value={get(store, "id")}
          >
            {get(store, "name")}
          </Option>
        ))}
      </Select>
    );
  }
};

const AddToCartButton = ({ product, stores, options = {} }) => {
  const { id: productId, isOrderable } = product;
  if (!stores.length || !isOrderable) return null;

  const router = useRouter();
  const { itemAdd } = useCart();

  const [count, setCount] = useState(1);
  const [store, setStore] = useState(get(stores, "[0].id"));
  const [loading, setLoading] = useState(false);

  async function handleAddToCart(e) {
    setLoading(true);
    const options = {};
    if (router?.query?.hash) {
      options.hash = get(router, 'query.hash');
    }
    itemAdd(count, store, productId, () => {
      TagManager.push(EnhancedEcommerce.cartAdd(get(options, 'eecProduct'), count));
      setLoading(false)
    }, options);
    return false;
  }

  return (
    <>
      <InputNumber
        min={1}
        max={999}
        defaultValue={1}
        onChange={(value) => setCount(value)}
        style={{marginRight: '10px'}}
      />
      <Button
        type="primary"
        loading={loading}
        onClick={(e) => handleAddToCart(e)}
        icon={<ShoppingOutlined />}
      >
        Objednať{" "}
      </Button>
    </>
  );
};

export default AddToCartButton;
